import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import crypto from "../../../Assets/Projects/NLP/Crypto.png";
import crypto2 from "../../../Assets/Projects/NLP/Crypto2.png";
import crypto3 from "../../../Assets/Projects/NLP/Crypto3.png";
import crypto4 from "../../../Assets/Projects/NLP/Crypto4.png";
import crypto5 from "../../../Assets/Projects/NLP/Crypto5.png";

function CryptoAcademySentimentAnalysis() {
  return (
    <ProjectDetailCard
      title="Sentiment Analysis of Akademi Crypto Reviews"
      image={crypto}
      screenshots={[crypto2, crypto3, crypto4]}
      description="
      Sentiment Analysis of Akademi Crypto Reviews is a Natural Language Processing (NLP) project developed to analyze public opinions toward Akademi Crypto based on customer reviews collected from online platforms. The project applies comprehensive text preprocessing techniques and machine learning algorithms to classify reviews into positive, neutral, and negative sentiments. In addition to sentiment classification, the system provides visual analytics and meaningful insights that help evaluate user satisfaction, identify recurring issues, and support data-driven improvements for educational services and digital learning platforms.
      "
      technologies={[
        "Python",
        "Scikit-learn",
        "NLTK",
        "Sastrawi",
        "TF-IDF",
        "Pandas",
        "NumPy",
        "Matplotlib",
        "WordCloud",
        "Google Colab",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={crypto5} alt="gallery1" />
          <img src={crypto4} alt="gallery2" />
          <img src={crypto3} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default CryptoAcademySentimentAnalysis;
